<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt width="25" height="25" />
      <p class="title-bk">生徒登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'student' }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_student.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitForm)" ref="form">
          <table class="table table-form">
            <tbody>
              <ChoiceField
                v-model="corporationChoiceFieldMultiModels"
                extraRules="required_select"
                label="法人名（法人ID）"
                placeholder="選択して下さい"
                resourceType="corporation"
                modelFieldName="corporation"
                :choiceDisable="loggedInAsCorporation || loggedInAsBrand || loggedInAsSchool || loggedInAsTeacher"
                :childFieldNames="['brand', 'school', 'course', 'tamaiClass']"
                :formData="currentStudent"
              />
              <ChoiceField
                v-model="brandChoiceFieldMultiModels"
                extraRules="required_select"
                label="ブランド名（ブランドID）"
                placeholder="選択して下さい"
                resourceType="brand"
                modelFieldName="brand"
                :choiceDisable="
                  loggedInAsBrand || loggedInAsSchool || loggedInAsTeacher || isEmpty(currentStudent.corporation)
                "
                :childFieldNames="['school', 'course', 'tamaiClass']"
                :formData="currentStudent"
              />
              <ChoiceField
                v-model="schoolChoiceFieldMultiModels"
                extraRules="required_select"
                label="教場名（教場ID）"
                placeholder="選択して下さい"
                resourceType="school"
                modelFieldName="school"
                :choiceDisable="loggedInAsSchool || isEmpty(currentStudent.brand)"
                :childFieldNames="['tamaiClass']"
                :formData="currentStudent"
              />
              <ChoiceField
                v-model="courseChoiceFieldMultiModels"
                extraRules="required_select"
                label="コース名（コースID）"
                placeholder="選択して下さい"
                resourceType="course"
                modelFieldName="course"
                :choiceDisable="isEmpty(currentStudent.brand)"
                :childFieldNames="['tamaiClass']"
                :formData="currentStudent"
              />
              <ChoiceField
                v-model="tamaiClassChoiceFieldMultiModels"
                extraRules="required_select"
                label="クラス名（クラスID）"
                placeholder="選択して下さい"
                resourceType="class"
                modelFieldName="tamaiClass"
                :choiceDisable="
                  isEmpty(currentStudent.brand) || isEmpty(currentStudent.school) || isEmpty(currentStudent.course)
                "
                :formData="currentStudent"
              />
              <br />
              <IdInputField
                v-model="currentStudent.uid"
                extraRules="required"
                label="生徒ID"
                placeholder="半角英数字で入力してください（-、_は可）"
                inputClass="col-lg-6"
                resourceType="student"
              />
              <StudentPasswordField vid="password" v-model="currentStudent.password" extraRules="required" />
              <StudentPasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
              <br />
              <TextField v-model="currentStudent.name" label="生徒名" extraRules="required" />
              <TextField
                v-model="currentStudent.nameKana"
                label="生徒名（フリガナ）"
                placeholder="全角カタカナ"
                extraRules="required"
              />
              <TextField
                v-model="currentStudent.nameRomaji"
                label="生徒名（ローマ字）"
                placeholder="半角英字"
                extraRules="required"
              />
              <tr>
                <th scope="row" width="25%">生年月</th>
                <td width="10%">
                  <span class="bg-red">必須</span>
                </td>
                <td class="form-inline no-margin-top">
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentStudent.yearOfBirth"
                      placeholder="選択してください"
                      class="form-control select-year"
                      :class="classes"
                      :clearable="false"
                      :options="years"
                    />
                    <span class="select-text">年</span>
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentStudent.monthOfBirth"
                      placeholder="選択してください"
                      class="form-control select-month"
                      :class="classes"
                      :clearable="false"
                      :options="months"
                    />
                    <span class="select-text">月</span>
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                </td>
              </tr>
              <SelectField
                label="性別"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="genders"
                optionValue="id"
                optionLabel="name"
                v-model="currentStudent.genderId"
              />
              <SelectField
                label="国籍"
                extraRules="required_select"
                inputClass="col-lg-8"
                placeholder="選択してください"
                :options="countries"
                optionValue="id"
                optionLabel="companyjp"
                v-model="currentStudent.countryOfCitizenshipId"
              />
              <SelectField
                label="居住国"
                extraRules="required_select"
                inputClass="col-lg-8"
                placeholder="選択してください"
                :options="countries"
                optionValue="id"
                optionLabel="companyjp"
                v-model="currentStudent.countryOfResidenceId"
              />
              <SelectField
                label="学年"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="schoolYears"
                optionValue="id"
                optionLabel="name"
                v-model="currentStudent.schoolYearId"
              />
              <TextField
                v-model="currentStudent.address"
                label="住所"
                placeholder="例）京都府京都市"
                extraRules="required"
              />
              <br />
              <TeachingMaterialCheckBox
                label="利用教材"
                extraRules="required_select"
                inputClass="col-lg-8"
                :options="teachingMaterialOptions"
                optionValue="code"
                optionLabel="name"
                v-model="currentStudent.figuredTeachingMaterialCodes"
              />
              <tr>
                <th scope="row" width="25%">IDの有効化</th>
                <td width="10%">
                  <span class="bg-red">必須</span>
                </td>
                <td>
                  <ValidationProvider mode="eager" rules="required_select" v-slot="{ invalid, errors }">
                    <form>
                      <div class="form-row align-items-center">
                        <div class="col-auto my-1">
                          <div class="radio" v-for="activation in activations" :key="activation.id">
                            <input
                              class="radio-input"
                              type="radio"
                              name="activation"
                              :id="activation.key"
                              :value="activation.id"
                              v-model="currentStudent.activationId"
                              @change="choseActivationId"
                            />
                            <label class="radio-label" :for="activation.key">
                              {{ activation.name }}
                              <small class="text-danger" v-if="activation.note">{{ activation.note }}</small>
                            </label>
                            <div class="reservation-select" v-if="activation.id == '3'">
                              <ValidationProvider
                                mode="eager"
                                :rules="reservationRequiredRule"
                                v-slot="{ classes, invalid, errors }"
                              >
                                <v-select
                                  tag="div"
                                  v-model="currentStudent.preRegistrationMonth"
                                  placeholder="選択してください"
                                  class="select-control"
                                  :clearable="false"
                                  :options="currentStudent.activationId == '3' ? getActivationMonths : []"
                                  label="text"
                                >
                                </v-select>
                                <div class="invalid-feedback" v-if="!disableRegistration && invalid">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { studentBirthYears, monthsOfYear } from '@/utils/year_helpers';
import EventBus from '@/helpers/EventBus.js';
import ChoiceField from '@/components/forms/ChoiceField.vue';
import IdInputField from '@/components/forms/IdInputField.vue';
import StudentPasswordField from '@/components/forms/StudentPasswordField.vue';
import TextField from '@/components/forms/TextField.vue';
import SelectField from '@/components/forms/SelectField.vue';
import TeachingMaterialCheckBox from '@/components/forms/TeachingMaterialCheckBox.vue';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
  basicTamaiClassNameIdPresent,
} from '@/presenters/fields';
import { filterTeachingMaterialsByProducts } from '@/utils/teaching_material_helpers';

export default {
  data() {
    return {
      verifyPassword: '',
      currentStudent: {},
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    ChoiceField,
    StudentPasswordField,
    TextField,
    SelectField,
    IdInputField,
    TeachingMaterialCheckBox,
  },
  computed: {
    corporationChoiceFieldMultiModels() {
      return basicCorporationNameIdPresent(this.currentStudent.corporation);
    },
    brandChoiceFieldMultiModels() {
      return basicBrandNameIdPresent(this.currentStudent.brand);
    },
    schoolChoiceFieldMultiModels() {
      return basicSchoolNameIdPresent(this.currentStudent.school);
    },
    courseChoiceFieldMultiModels() {
      return basicCourseNameIdPresent(this.currentStudent.course);
    },
    tamaiClassChoiceFieldMultiModels() {
      return basicTamaiClassNameIdPresent(this.currentStudent.tamaiClass);
    },
    years() {
      return studentBirthYears(1980);
    },
    months() {
      return monthsOfYear();
    },
    disableRegistration() {
      return !(this.currentStudent.activationId == '3');
    },
    reservationRequiredRule() {
      return this.currentStudent.activationId == '3' ? 'required_select' : '';
    },
    teachingMaterialOptions() {
      if (this.currentStudent.corporation) {
        const allTeachingMaterials = this.teachingMaterials;
        const userProducts = this.currentStudent.corporation.figuredProducts;
        const userTeachingMaterials = filterTeachingMaterialsByProducts(allTeachingMaterials, userProducts);
        return userTeachingMaterials;
      } else {
        return [];
      }
    },
    ...mapState({
      editingStudent: (state) => state.student.editingStudent,
      genders: (state) => state.gender.genders,
      countries: (state) => state.country.countries,
      schoolYears: (state) => state.school_year.schoolYears,
      teachingMaterials: (state) => state.teaching_material.teachingMaterials,
      activations: (state) => state.activation.activations,
    }),
    ...mapState('form', ['prevFormData']),
    ...mapState(['corporation']),
    ...mapState(['brand']),
    ...mapState(['school']),
    ...mapState(['teacher']),
    ...mapGetters('auth', ['loggedInAsCorporation', 'loggedInAsBrand', 'loggedInAsSchool', 'loggedInAsTeacher']),
    ...mapGetters('activation', ['getActivationMonths']),
  },
  async mounted() {
    EventBus.$on('SET_USER_PROFILE', this.setCurrentRoleHandler);
    await this.fetchSchoolYears();
  },
  created() {
    this.currentStudent = this.createFreshStudentObject();
  },
  beforeDestroy() {
    EventBus.$off('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  methods: {
    createFreshStudentObject() {
      if (this.editingStudent) {
        // Reset content of pulldown when reselecting corporation.
        this.editingStudent.figuredTeachingMaterialCodes = [];
        this.$logger.debug('Editing old Student with ID ' + this.editingStudent);
        return this.editingStudent;
      } else if (this.prevFormData) {
        // Reset content of pulldown when reselecting corporation.
        this.prevFormData.figuredTeachingMaterialCodes = [];
        this.$logger.debug('Restoring previous form data', this.prevFormData);
        return this.prevFormData;
      } else {
        let newStudent = {
          corporation: null,
          brand: null,
          school: null,
          course: null,
          tamaiClass: null,
          uid: '',
          password: '',
          name: '',
          nameKana: '',
          nameRomaji: '',
          yearOfBirth: '',
          monthOfBirth: '',
          genderId: '',
          countryOfCitizenshipId: '',
          countryOfResidenceId: '',
          schoolYearId: '',
          address: '',
          figuredTeachingMaterialCodes: [],
          activationId: '',
        };
        if (this.loggedInAsCorporation) {
          newStudent['corporation'] = this.corporation.corporation;
        }
        if (this.loggedInAsBrand) {
          newStudent['brand'] = this.brand.brand;
          newStudent['corporation'] = this.brand.brand.corporation;
        }
        if (this.loggedInAsSchool) {
          newStudent['school'] = this.school.school;
          newStudent['brand'] = this.school.school.brand;
          newStudent['corporation'] = this.school.school.corporation;
        }

        if (this.loggedInAsTeacher) {
          newStudent.corporation = this.teacher.teacher.corporation;
          newStudent.brand = this.teacher.teacher.brand;
        }

        return newStudent;
      }
    },
    submitForm() {
      this.$logger.debug('Started Adding: ' + JSON.stringify(this.currentStudent));
      this.startEditingStudent(this.currentStudent);
      this.$router.push({ name: 'student-confirm' });
    },
    setCurrentRoleHandler(payload) {
      if (this.loggedInAsCorporation) {
        this.currentStudent.corporation = payload.data;
      }

      if (this.loggedInAsBrand) {
        this.currentStudent.brand = payload.data;
        this.currentStudent.corporation = payload.data.corporation;
      }

      if (this.loggedInAsSchool) {
        this.currentStudent.school = payload.data;
        this.currentStudent.brand = payload.data.brand;
        this.currentStudent.corporation = payload.data.corporation;
      }

      if (this.loggedInAsTeacher) {
        this.currentStudent.teacher = payload.data;
        this.currentStudent.brand = payload.data.brand;
        this.currentStudent.corporation = payload.data.corporation;
      }
    },
    choseActivationId() {
      this.$logger.debug('Picked Activation Id: ' + this.currentStudent.activationId);
      if (this.currentStudent.activationId != '3') {
        this.currentStudent.preRegistrationMonth = null;
      }
    },
    ...mapActions('student', ['startEditingStudent']),
    ...mapActions('school_year', ['fetchSchoolYears']),
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  padding-bottom: 6px;
}
.section-subtitle {
  padding-bottom: 12px;
}
form.inline-form {
  display: inline-block;
}
.checkbox .checkbox-input {
  margin-right: 5px;
}
.radio .radio-input {
  margin-right: 5px;
}
.radio .reservation-select {
  display: inline-grid;
}
.img-inline {
  margin-left: 5px;
}
.body-td-explain {
  margin-left: 5px;
  font-size: 10px;
}
.line-break {
  width: 100%;
}
.btn-confirm {
  margin-left: 0px;
}

/deep/ .v-select-birth {
  .select-month,
  .select-year {
    padding: 0px 2px 0px 10px;
    max-width: initial;
    margin-right: 10px;
    .vs__dropdown-toggle {
      width: 146px;
    }
  }
  .select-text {
    margin-right: 35px;
  }
}
.select-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 12px;
  width: 200px;
}
</style>
